import React from 'react';
import './Sidebar.css';

interface SidebarProps {
  currentView?: string;
  onNavigate?: (view: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, onNavigate }) => {
  const getActiveMenuItem = (view?: string): string => {
    if (!view) return 'dashboard';
    
    if (view.startsWith('harvest-') || view === 'harvest') return 'harvest';
    if (view.startsWith('capture-') || view === 'capture') return 'capture';
    if (view.startsWith('library-') || view === 'library') return 'library';
    if (view.startsWith('admin-') || view === 'admin') return 'admin';
    
    return 'dashboard';
  };

  const [activeSection, setActiveSection] = React.useState(getActiveMenuItem(currentView));

  React.useEffect(() => {
    setActiveSection(getActiveMenuItem(currentView));
  }, [currentView]);

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/dashboard'
    },
    {
      id: 'harvest',
      label: 'HARVEST',
      icon: '📥',
      path: '/harvest',
      description: 'Collection & Upload'
    },
    {
      id: 'capture',
      label: 'CAPTURE',
      icon: '🔍',
      path: '/capture',
      description: 'Review & Processing'
    },
    {
      id: 'library',
      label: 'LIBRARY',
      icon: '📚',
      path: '/library',
      description: 'Search & Archive'
    },
    {
      id: 'admin',
      label: 'Admin',
      icon: '⚙️',
      path: '/admin',
      description: 'Property Management'
    }
  ];

  const handleSectionClick = (section: string) => {
    setActiveSection(section);
    if (onNavigate) {
      onNavigate(section);
    }
  };

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.id} className="sidebar-menu-item">
              <button
                className={`sidebar-menu-button ${activeSection === item.id ? 'sidebar-menu-button-active' : ''}`}
                onClick={() => handleSectionClick(item.id)}
              >
                <span className="sidebar-menu-icon">{item.icon}</span>
                <div className="sidebar-menu-content">
                  <span className="sidebar-menu-label">{item.label}</span>
                  {item.description && (
                    <span className="sidebar-menu-description">{item.description}</span>
                  )}
                </div>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
